import { useState, useEffect } from 'react';
import { useUsers } from '../context/UserContext';
import { UserFormData } from '../services/userService';
import { User } from '../types/user';
import { toast } from 'react-hot-toast';

export const useUserManagement = () => {
  const { users, loading, error, fetchUsers, createUser, updateUser, deleteUser } = useUsers();
  const [selectedUser, setSelectedUser] = useState<UserFormData | null>(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEditUser = (user: User) => {
    setSelectedUser({
      id: user.id,
      lastName: user.lastName,
      firstName: user.firstName,
      middleName: user.middleName,
      email: user.email,
      role: user.role,
      roles: user.roles?.length ? user.roles : [user.role],
      status: user.status
    });
  };

  const handleCreateUser = async (userData: UserFormData) => {
    try {
      await createUser(userData);
      await fetchUsers();
      toast.success('Пользователь успешно создан');
    } catch (error) {
      console.error('Ошибка при создании пользователя:', error);
      toast.error('Ошибка при создании пользователя');
    }
  };

  const handleUpdateUser = async (userData: UserFormData) => {
    if (!userData.id) {
      toast.error('Не удалось определить пользователя для обновления');
      return;
    }

    try {
      await updateUser(userData.id, userData);
      await fetchUsers();
      toast.success('Пользователь успешно обновлен');
    } catch (error) {
      console.error('Ошибка при обновлении пользователя:', error);
      toast.error('Ошибка при обновлении пользователя');
      throw error;
    }
  };

  const handleDeleteUser = async (userId: string) => {
    try {
      await deleteUser(userId);
      await fetchUsers();
      toast.success('Пользователь успешно удален');
    } catch (error) {
      console.error('Ошибка при удалении пользователя:', error);
      toast.error('Ошибка при удалении пользователя');
    }
  };

  return {
    users,
    loading,
    error,
    selectedUser,
    setSelectedUser,
    handleEditUser,
    handleCreateUser,
    handleUpdateUser,
    handleDeleteUser
  };
}; 